import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {AuthenticationComponent} from './authentication.component';
import {LoginComponent} from "@app/authentication/components/login/login.component";
import {RegisterFormComponent} from "@app/authentication/components/register-form/register-form.component";
import {ForgotPasswordComponent} from "@app/authentication/components/forgot-password/forgot-password.component";
import {UpdateBoschIdComponent} from "@app/authentication/components/update-bosch-id/update-bosch-id.component";
import {MsalRedirectGuard} from './guards/msal-redirect.guard';

const authRoutes: Routes = [
    {
        path: 'auth', component: AuthenticationComponent, canActivate: [MsalRedirectGuard], children: [
            {path: '', redirectTo: '/auth/login', pathMatch: 'full'},
            {path: 'login', component: LoginComponent},
            {path: 'update-bosch-id', component: UpdateBoschIdComponent},
            {path: 'register', component: RegisterFormComponent},
            {path: 'forgot-password', component: ForgotPasswordComponent}
        ]
    }
];

@NgModule({
    imports: [RouterModule.forRoot(authRoutes, {relativeLinkResolution: 'legacy'})],
    exports: [RouterModule]
})
export class AuthRoutingModule {
}
